import { all } from 'redux-saga/effects';
import * as LoginSaga from './components/login/saga';
import * as TheodoreLoginSaga from './components/Theodore/login/saga';
import * as SignUpSaga from './Admin/Analyst/Create/saga';
import * as ForgotPasswordSaga from './components/forgot-password/saga';
import * as ForgotTheodorePasswordSaga from './components/Theodore/forgot-password/saga'
import * as AnalystsListSaga from './Admin/Analyst/List/saga';
import * as CreditLimitAddSaga from './Admin/CreditLimit/Create/saga';
import * as ViewCreditLimitSaga from './Admin/CreditLimit/View/saga';
import * as EditCreditLimitSaga from './Admin/CreditLimit/Edit/saga';
import * as DefaultProductListSaga from './Admin/Corporate/DefaultProduct/saga'
import * as NewsFeedsModerationSaga from './Analyst/News-Moderation/saga';
import * as SectionTemplateCreateSaga from './Admin/SectionTemplate/Create/saga';
import * as SectionTemplateViewSaga from './Admin/SectionTemplate/View/saga'
import * as SectionTemplateListSaga from './Admin/SectionTemplate/List/saga';
// import * as MasterDataKeyListSaga from './Admin/GlobalConfigurations/ViewMasterData/saga';
import * as CaseListSaga from './Analyst/Cases/List/saga';
import * as ScorecardListSaga from './Admin/Scorecard/List/saga';
import * as ScorecardCreateSaga from './Admin/Scorecard/Create/saga';
import * as AutoSuggestSaga from './components/ReusableComponents/AutoSuggest/saga';
import * as RiskFactorSearchSaga from './Admin/RiskFactor/Search/saga';
import * as RiskFactorViewSaga from './Admin/RiskFactor/View/saga';
import * as RiskFactorListSaga from './Admin/RiskFactor/List/saga';
import * as adminDashBoardSaga from './Admin/admin-dashboard/saga';
import * as CaseViewSaga from './Analyst/Cases/View/saga';
import * as commonSaga from './components/Services/saga';
import * as CaseCreateSaga from './Analyst/Cases/Create/saga';
import * as OverriddingCreateSaga from './Admin/RiskFactor/OverridingRiskFactor/Create/saga';
import * as OverriddingListSaga from './Admin/RiskFactor/OverridingRiskFactor/List/saga';
import * as AutomatedOverriddingCreateSaga from './Admin/RiskFactor/AutomatedOverridingRiskFactor/Create/saga';
import * as AutomatedOverriddingListSaga from './Admin/RiskFactor/AutomatedOverridingRiskFactor/List/saga';

import * as CorporateSaga from './Corporate/corporate/saga';
import * as CreditUsageSaga from './Corporate/usage-stats/saga';
import * as PortfolioSaga from './Corporate/my-portfolio/saga';
import * as CorporateBulkCaseRequestSaga from './Corporate/bulk-case-request/saga'
import * as AlertsSaga from './Corporate/Sidebar/saga';
import * as CorporateOnBoardingSaga from './Admin/Corporate/Create/saga';
import * as KibanaConfig from './Admin/Corporate/DIYReportSetup/saga';
import * as CorporateReportsaga from './Corporate/Credit-worthiness-dashboard/saga';
import * as CorporateDashboardSaga from './Corporate/dashboard/saga'
import * as CorporateListSaga from './Admin/Corporate/List/saga';
import * as CorrespondentList from './Correspondent/Tasks/saga';
import * as CorrespondentTaskList from './Correspondent/TaskDetails/saga';
import * as CorrespondentBilling from './Admin/Billing/saga';
import * as CorrespondentCreate from './Admin/Correspondent-Onboarding/Create/saga';
import * as CorrespondentAdminList from './Admin/Correspondent-Onboarding/List/saga';
//import * as CredenceSaga from './Admin/Credence/saga';
import * as GlobalConfigurationSaga from './Admin/GlobalConfigurations/saga';
import * as BulkCaseSaga from './Analyst/Cases/Bulk-Case/saga';
import * as KibanaConfigFetch from './Corporate/Kibana/saga';
import * as CommonCaseComponent from './Analyst/Cases/CommonComponent/saga';
import * as ChangePasswordComponent from './components/change-password/saga';
import * as FetchQuickReportCases from './Analyst/Cases/Bulk-Case/QuickReportBulkCase/saga'
import * as LegalModerationData from './Analyst/Cases/View/LegalModeration/saga';
import * as NewsModerationData from './Analyst/Cases/View/NewsModeration/saga';
import * as CUGPortfolioSaga from './Corporate/my-portfolio/cug-portfolio/saga';
import * as ServerOnSaga from './Admin/admin-header/ServerOnModal/saga'
import * as RatingcompanyMapSaga from './Analyst/Cases/RatingCompanyMap/saga'
import * as MonitoringDataSaga from './Corporate/my-portfolio/monitoring/saga';
import * as CounterpartySearchSaga from './Admin/Counterparty/Search/saga';
import * as RatingsDataUploadSaga from './Admin/Counterparty/RatingsDataUpload/saga'
import * as AllocatePartnerSaga from './Analyst/Cases/View/AllocatePartner/saga'
import * as InternationalSaga from './Admin/International/saga'
import * as EWSSaga from './Admin/early-warning-system/saga'
import * as APICasesExtractSaga from './Analyst/Cases/Api/saga'
import * as DataUploadSaga from './Admin/Data-Upload/saga'
import * as VendorDataSaga from './Admin/Vendor-Tracker/saga'
import * as MisFormFieldSaga from './Admin//Mis-Form-Fields/saga'
import * as AutomatedRevenueSaga from './Analyst/Cases/View/EditSection/AutomatedRevenueForm/saga'
import * as AutomatedBenchmarkSaga from './Analyst/Cases/View/EditSection/AutomatedBenchmarkForm/saga'
import * as CreditLimitEditSectionSaga from './Analyst/Cases/View/EditSection/CreditLimitEditSection/saga'
import * as KycUsageSaga from './Admin/KycUsage/saga';
import * as EwsReportSaga from './Corporate/my-portfolio/monitoring/ews-charts/ewsReport/saga'
import * as MeteringSystemSaga from './Admin/Metering-System/saga'
import * as MeteringCorporateListSaga from './Admin/Corporate/MeteringStats/saga';
import * as CorporateCaseCount from './Admin/Metering-System/CorprateCaseCount/saga';
import * as MisTeamSaga from './Admin/Mis-Team/saga';
import * as ActivityLogSaga from './Admin/ActivityLog/saga';
import * as IfscMasterSaga from './Admin/IfscMaster/saga';
import * as CorporateMasterSaga from './Admin/corporateMaster/saga'
import * as LocalPartyMasterSaga from './Admin/LocalPartyMaster/saga';
import * as IfscUserMasterSaga from './Admin/IfscUserMaster/saga';
import * as CorporateBillingMasterSaga from './Admin/CorporateBillingMaster/saga';
import * as UserAccessMgtSaga from './Admin/userAccessManagement/saga'
import * as PartnerCostSaga from './Admin/Partner-Cost/saga';
import * as DatabaseRequestCase from './Analyst/Cases/Database/saga'
//import * as AllUsersListSaga from './Admin/user-management/all-users/saga';
import * as CountryIndustryReports from './Admin/Country-Industry-Reports/saga';
import * as AllUsersListSaga from './Admin/user-management/all-users/saga';
import * as SupportWorkAutomationSaga from './Admin/Support-Work-Automation/saga';
import * as corporateBulkEndUserSaga from './Admin/Corporate/CreateBulkEndUser/saga';
import * as BulkCaseUpdationSaga from './Analyst/Cases/Bulk-Case-Updation/saga';

export default function* rootSaga() {
    yield all([
        LoginSaga.login(),
        TheodoreLoginSaga.theodoreLogin(),

        SignUpSaga.signUp(),

        ForgotPasswordSaga.forgotPassword(),
        ForgotTheodorePasswordSaga.theodoreGetEmailOtp(),
        ForgotTheodorePasswordSaga.theodoreResetPassword(),

        AlertsSaga.getAlertListSaga(),
        AlertsSaga.getGeneralNewsListSaga(),
        AlertsSaga.updateReadStatus(),

        AnalystsListSaga.getAnalystsListSaga(),
        AnalystsListSaga.deleteAnalyst(),

        AllUsersListSaga.watchUsersSaga(),
        DefaultProductListSaga.getIAllDefaultProductListSaga(),
        DefaultProductListSaga.productTemplateEdit(),
        NewsFeedsModerationSaga.getNewsFeedsSaga(),
        NewsFeedsModerationSaga.searchCounterpartyNameSaga(),
        NewsFeedsModerationSaga.submitNewsFeedsSaga(),

        AutoSuggestSaga.getScorecardRiskFactorSearch(),
        AutoSuggestSaga.sectionTemplateSearch(),
        AutoSuggestSaga.getOverriddingRiskFactorSearch(),
        AutoSuggestSaga.getScorecardSearch(),
        AutoSuggestSaga.getCountryAutoCompleteSearch(),
        AutoSuggestSaga.getStateAutoCompleteSearch(),

        ScorecardCreateSaga.fetchScorecardDetails(),
        ScorecardCreateSaga.editScorecard(),
        ScorecardCreateSaga.createScorecard(),
        ScorecardCreateSaga.getCorporateSearchforScoreCard(),

        ScorecardListSaga.getScorecardList(),

        SectionTemplateCreateSaga.setSectionTemplate(),
        SectionTemplateCreateSaga.setSectionTemplateEdit(),
        SectionTemplateCreateSaga.sectionTemplateMapping(),
        SectionTemplateCreateSaga.sectionTemplateMappingEdit(),
        SectionTemplateCreateSaga.getmasterDataValue(),
        SectionTemplateCreateSaga.sectionTemplateConfig(),
        SectionTemplateCreateSaga.sectionTemplateType(),
        SectionTemplateCreateSaga.updateAPIKeyName(),

        SectionTemplateViewSaga.fetchSectionTemplateDetails(),
        SectionTemplateViewSaga.getSectionTemplateDownloadURL(),

        SectionTemplateListSaga.getSectionTemplateList(),
        SectionTemplateListSaga.uploadBulkMasterDataKey(),
        SectionTemplateListSaga.downloadMasterDataKeyTemplate(),

        OverriddingCreateSaga.addOveriddingRiskFactor(),
        OverriddingCreateSaga.fetchOveriddingRiskFactor(),
        OverriddingCreateSaga.editOveriddingRiskFactor(),
        OverriddingListSaga.listOveriddingRiskFactor(),

        AutomatedOverriddingCreateSaga.editAutomatedOveriddingRiskFactor(),
        AutomatedOverriddingCreateSaga.fetchAutomatedOveriddingRiskFactor(),
        AutomatedOverriddingCreateSaga.addAutomatedOveriddingRiskFactor(),
        AutomatedOverriddingListSaga.listAutomatedOveriddingRiskFactor(),


        adminDashBoardSaga.getDataAdminDashboard(),
        // createCorporateOnboardingSaga.getStatesList(),
        CorporateOnBoardingSaga.getStatesList(),
        CorporateOnBoardingSaga.getEditData(),

        RiskFactorListSaga.listRiskFactor(),
        RiskFactorListSaga.uploadRiskfactorEditTemplate(),
        RiskFactorListSaga.downloadRiskfactorEditTemplate(),

        RiskFactorSearchSaga.donwloadRiskFactorTemplate(),
        RiskFactorSearchSaga.uploadRiskFactorTemplate(),

        RiskFactorViewSaga.donwloadRiskFactorDetails(),
        RiskFactorViewSaga.fetchRiskFactorDetails(),
        RiskFactorViewSaga.uploadRiskFactorDetails(),

        CreditLimitAddSaga.addCreditLimitModelSaga(),
        ViewCreditLimitSaga.viewAllCreditLimitModelSaga(),
        EditCreditLimitSaga.editCreditLimitModelSaga(),
        EditCreditLimitSaga.updateCreditLimitModelSaga(),

        CaseListSaga.fetchCaseList(),
        CaseListSaga.fetchCorporateName(),
        CaseListSaga.downloadPendingCases(),
        CaseListSaga.fetchProductsByCorporatesWatcher(),

        CaseCreateSaga.getUserList(),
        CaseCreateSaga.getProductList(),
        CaseCreateSaga.getAllDivisionSubsidiary(),
        CaseCreateSaga.createCounterparty(),
        CaseCreateSaga.createCase(),
        CaseCreateSaga.createCaseSubscriptionOrDatabase(),
        CaseCreateSaga.createBulkBuy(),
        CaseCreateSaga.getCorporateSearch(),
        CaseCreateSaga.getCounterpartySearch(),
        CaseCreateSaga.getCounterpartytype(),
        CaseCreateSaga.getReportCategory(),
        CaseCreateSaga.getReportFrontCoverList(),
        CaseCreateSaga.getPortfolioCount(),
        CaseCreateSaga.getZone(),
        CaseCreateSaga.getZoneForState(),
        CaseCreateSaga.getIndianStates(),

        CommonCaseComponent.dataAutomationInitiate(),
        CommonCaseComponent.kyDataAutomationInitiate(),
        CommonCaseComponent.getKycCrawlerStatus(),
        CommonCaseComponent.getCrawlerStatus(),
        CommonCaseComponent.getCrawlerMarkasfail(),
        CommonCaseComponent.startLegalCrawler(),
        CommonCaseComponent.legalSectionTemplateRequest(),
        CommonCaseComponent.nicSearchRequest(),
        CommonCaseComponent.zigramSearchRequest(),
        CommonCaseComponent.zigramExcelRequest(),
        CommonCaseComponent.additionalLegalTemplate(),
        CommonCaseComponent.additionalLegalUpload(),
        CommonCaseComponent.amlPepTemplate(),
        CommonCaseComponent.masterDataSyncRequest(),
        CommonCaseComponent.itrAnalysisResync(),

        BulkCaseSaga.getUploadList(),
        BulkCaseSaga.getBulkCaseTemplate(),
        BulkCaseSaga.uploadBulkCases(),
        BulkCaseSaga.downloadBulkCasesFile(),
        BulkCaseSaga.uploadQuickBulkCases(),

        CorporateSaga.globalCounterpartySearch(),
        CorporateSaga.counterpartyView(),
        CorporateSaga.advancedGlobalCounterpartySearch(),
        CorporateSaga.setCorporateColor(),

        CaseViewSaga.fetchCaseDetails(),
        CaseViewSaga.fetchSections(),
        CaseViewSaga.sectionDetailFileDownload(),
        CaseViewSaga.surveyDetailFileDownload(),
        CaseViewSaga.surveyDataDetailFileDownload(),
        CaseViewSaga.showSectionPdf(),

        CaseViewSaga.sectionDetailFileUpload(),
        CaseViewSaga.getPredefinedSection(),
        CaseViewSaga.addPredefinedSection(),
        CaseViewSaga.publishFinalReport(),
        CaseViewSaga.reorder(),
        CaseViewSaga.previewCaseReport(),
        CaseViewSaga.predefinedSectionDownload(),
        CaseViewSaga.predefinedSectionUpload(),
        CaseViewSaga.previewCompletedCase(),
        CaseViewSaga.closeCase(),
        CaseViewSaga.caseScorecardDetails(),
        CaseViewSaga.caseExecutiveSummaryDetails(),
        CaseViewSaga.caseScorecardRationalDetails(),
        CaseViewSaga.fetchferreroKpi(),
        CaseViewSaga.editCaseScorecard(),
        CaseViewSaga.reCalculateScorecard(),
        CaseViewSaga.uploadMultipleImages(),
        CaseViewSaga.surveyFinancialDetailFileDownload(),
        CaseViewSaga.reopenCase(),
        CaseViewSaga.deletePredefinedSection(),
        CaseViewSaga.deleteMultipleSection(),
        CaseViewSaga.addDataSections(),
        CaseViewSaga.getDataSections(),
        CaseViewSaga.deleteDataSections(),
        CaseViewSaga.getCorrespondents(),
        CaseViewSaga.assignToCorrespondent(),
        CaseViewSaga.approveSection(),
        CaseViewSaga.rejectSection(),
        CaseViewSaga.downloadSubmitted(),
        CaseViewSaga.withdrawCase(),
        CaseViewSaga.fetchXbrlDetails(),
        CaseViewSaga.downloadXbrlFileDetails(),
        CaseViewSaga.uploadXbrlFileDetails(),
        CaseViewSaga.rerunXbrlProcessing(),
        CaseViewSaga.fetchCaseEPFDetails(),
        CaseViewSaga.fetchBsaEntityTypes(),
        CaseViewSaga.fetchBsaBankNames(),
        CaseViewSaga.fetchBsaAccountTypes(),
        CaseViewSaga.fectchAllComputedSectionTemplate(),
        CaseViewSaga.markCasePending(),
        CaseViewSaga.scoreBreakUpDetails(),
        CaseViewSaga.downloadAttachments(),
        CaseViewSaga.scoreSummaryDetails(),
     
        commonSaga.fetchComments(),
        commonSaga.postComments(),
        commonSaga.commentReadStatus(),
        commonSaga.fetchAggregateTypes(),
        commonSaga.fetchAggregateDirections(),
        commonSaga.fetchDataTypes(),
        commonSaga.fetchRiskcategory(),
        commonSaga.fetchSelectedCountryState(),
        commonSaga.fetchCorporateDetails(),
        // commonSaga.getCountryAutocomplete(),
        // PortfolioSaga.fetchPortfolioDetails(),


        /* CorporateOnBoardingSaga.fetchProductSectionList(),
        CorporateOnBoardingSaga.fetchRiskfactor(), */

        PortfolioSaga.fetchRiskLevels(),
        PortfolioSaga.fetchCaseStatus(),
        PortfolioSaga.fetchLegalConstitution(),
        PortfolioSaga.fetchBusinessSegment(),
        PortfolioSaga.fetchProductList(),
        PortfolioSaga.fetchRiskTrend(),
        PortfolioSaga.getProductDescription(),
        PortfolioSaga.searchPortfolioList(),
        PortfolioSaga.getCugCorpData(),
        PortfolioSaga.fetchCaseTypes(),

        CreditUsageSaga.fetchCreditUsageData(),
        CreditUsageSaga.downloadCreditUsageData(),
        CreditUsageSaga.fetchCreditUsageGraphTileData(),
        CreditUsageSaga.fetchProductNameData(),

        CorporateBulkCaseRequestSaga.getBulkReportRequests(),
        CorporateBulkCaseRequestSaga.getBulkReportRequestTemplate(),
        CorporateBulkCaseRequestSaga.submitBulkReportRequest(),
        CorporateBulkCaseRequestSaga.getRecordRequestFile(),

        CorporateReportsaga.fetchReportDetails(),
        CorporateReportsaga.fetchPaymentScoreDetails(),
        CorporateReportsaga.fetchCugScoreDetails(),
        CorporateReportsaga.fetchPaymentRiskGrades(),
        CorporateReportsaga.reportDataCheck(),
        CorporateReportsaga.fetchCounterpartyReports(),
        CorporateReportsaga.fetchSections(),
        CorporateReportsaga.showSectionPdf(),
        CorporateReportsaga.downloadReportPdf(),
        CorporateDashboardSaga.getDashboardData(),
        CorporateDashboardSaga.checkDashboardData(),
        CorporateDashboardSaga.caseCountByState(),
        CorporateReportsaga.updateBPRStatusCheck(),

        PortfolioSaga.fetchRiskLevels(),

        CorporateOnBoardingSaga.fetchCreditLimitModelList(),
        CorporateOnBoardingSaga.fetchProductSectionList(),
        CorporateOnBoardingSaga.fetchRiskfactor(),
        CorporateOnBoardingSaga.corporateOnboardingData(),
        CorporateOnBoardingSaga.corporateOnboardingDataEdit(),
        CorporateOnBoardingSaga.oneClickCorporateOnboarding(),
        CorporateOnBoardingSaga.addDefaultProducts(),
        CorporateOnBoardingSaga.fetchMisFields(),
        CorporateOnBoardingSaga.fetchMisFieldsByCorporateId(),
        CorporateOnBoardingSaga.fetchIsMisOrderIdMandatoryByCorporateId(),
        CorporateOnBoardingSaga.fetchDefaultMisFields(),
        CorporateOnBoardingSaga.fetchEwsSelectPlanName(),
        
        corporateBulkEndUserSaga.corporateBulkEndUserSagaFetch(),

        KibanaConfig.setKibanaConfig(),
        KibanaConfig.downloadKeyExtracion(),

        MeteringCorporateListSaga.getReportByDates(),
        MeteringCorporateListSaga.getMeteringCorporateList(),

        CorporateListSaga.getCorporate(),
        CorporateListSaga.checkTransactionDataExist(),
        CorporateListSaga.transactionDataFileUpload(),
        CorporateListSaga.fetchTransactionDataList(),
        CorporateListSaga.downloadTransactionTemplate(),
        CorporateListSaga.deleteTransactionData(),
        CorporateListSaga.downloadTransactionFile(),
        CorporateListSaga.downloadExcelFile(),
        CorporateListSaga.downloadNonFinancialExcelFile(),
        CorporateListSaga.downloadObjectListExcelFile(),
        CorporateListSaga.downloadScoreBreakupExcelFile(),   
        CorporateListSaga.downloadCLMBreakupExcelFile(),
        CorporateListSaga.watchDownloadCorporateCSV(),

        CorrespondentList.getTaskList(),

        CorrespondentTaskList.fetchTasksDetails(),
        CorrespondentTaskList.downloadAllTaskDetails(),
        CorrespondentTaskList.downloadTask(),
        CorrespondentTaskList.uploadTask(),

        CorrespondentBilling.fetchPaginatedBillingList(),
        CorrespondentBilling.downloadBillingDetailsExcel(),
        CorrespondentBilling.fetchCorrespondentListBilling(),

        CorrespondentCreate.fetchCorrespondentEntityDetails(),
        CorrespondentCreate.createCorrespondentEntityDetails(),
        CorrespondentCreate.editCorrespondentEntity(),

        CorrespondentAdminList.enableCorrespondentEntity(),
        CorrespondentAdminList.getCorrespondent(),
        CorrespondentAdminList.deleteCorrespondentEntity(),
        //credence
        // CredenceSaga.startCredenceJob(),
        // CredenceSaga.killCredenceJob(),
        // CredenceSaga.findCredenceJobStatus(),

        GlobalConfigurationSaga.createGlobalConfiguration(),
        GlobalConfigurationSaga.fetchGlobalConfiguration(),
        GlobalConfigurationSaga.fetchVariablePredefinedField(),
        GlobalConfigurationSaga.fetchAggregatePredefinedField(),
        GlobalConfigurationSaga.getMasterDataList(),
        GlobalConfigurationSaga.createMasterDataKey(),
        GlobalConfigurationSaga.downloadXbrlMasterTemplate(),
        GlobalConfigurationSaga.uploadXbrlMasterTemplate(),
        GlobalConfigurationSaga.fetchXbrlMappingStatistics(),
        GlobalConfigurationSaga.fetchMasterKeyByApiKey(),
        GlobalConfigurationSaga.getBulkMasterKeyRequestTemplate(),
        GlobalConfigurationSaga.submitBulkMasterKeyRequest(),
        GlobalConfigurationSaga.fetchApiAccessesInfo(),
        GlobalConfigurationSaga.submitApiAccesses(),
        GlobalConfigurationSaga.fetchApiAccessTypes(),

        KibanaConfigFetch.fetchKibanaConfig(),
        //change password
        ChangePasswordComponent.changePassword(),
        ChangePasswordComponent.validateJwtToken(),

        FetchQuickReportCases.fetchQuickReportCases(),
        FetchQuickReportCases.fetchProductDetailByProductId(),
        FetchQuickReportCases.uploadSectionData(),
        FetchQuickReportCases.downloadManualSectionTemplateForQuickReport(),
        FetchQuickReportCases.downloadQuickReportCaseSummary(),
        FetchQuickReportCases.downloadQuickReportCaseCreationTemplate(),
        FetchQuickReportCases.downloadQuickReportStatusFile(),
        FetchQuickReportCases.downloadQuickReportCrawlerStatusFile(),
        //start/stop crawler job
        FetchQuickReportCases.initiateOrStopQuickCrawlers(),
        
        //Legal Moderation
        LegalModerationData.fetchUnprocessedLegalData(),
        LegalModerationData.postProcessedDataToServer(),
        LegalModerationData.fetchUnprocessedAdditionalLegalData(),
        LegalModerationData.postProcessedAdditionalLegalDataToServer(),
        LegalModerationData.watchDownloadBulkDeleteTemplate(),
        LegalModerationData.watchUploadBulkDeleteExcel(),
        //News Moderation
        NewsModerationData.fetchUnprocessedNewsDataFromServer(),
        NewsModerationData.postProcessedNewsDataToServer(),

        //CUG
        CUGPortfolioSaga.fetchCUGPortfolioList(),
        CUGPortfolioSaga.fetchCUGPaymentScoreDataRequest(),
        CUGPortfolioSaga.fetchMonthFilter(),
        CUGPortfolioSaga.fetchBreakupOfBusinessRequest(),
        CUGPortfolioSaga.fetchCUGPaymentScoreDataByBuisnessTypeRequest(),
        CUGPortfolioSaga.fetchCUGPortfolioListBySearch(),
        CUGPortfolioSaga.fetchCUGList(),
        CUGPortfolioSaga.uploadCUGData(),

        ServerOnSaga.updateServerOnDatesData(),

        RatingcompanyMapSaga.fetchMappedCompanyNameData(),
        RatingcompanyMapSaga.fetchCompanyNameListData(),
        RatingcompanyMapSaga.saveMappedCompaniesData(),
        
        //Monitoring Data         
        MonitoringDataSaga.uploadMonitoringData(),
        MonitoringDataSaga.downloadMonitoringCounterpartyData(),
        MonitoringDataSaga.fetchMonitoringList(),
        MonitoringDataSaga.createMonitoringMetadata(),
        MonitoringDataSaga.startMonitoringProcess(),
        MonitoringDataSaga.uploadMonitoringTemplateProcess(),
        MonitoringDataSaga.initiateMonitoringProcess(),
        MonitoringDataSaga.stopMonitoringProcess(),
        MonitoringDataSaga.downloadMonitoringCrawlerStatusFile(),
        MonitoringDataSaga.downloadConsolidatedMonitoringReport(),
        MonitoringDataSaga.fetchCorporateMonitoring(),
        MonitoringDataSaga.fetchMonitoringCorporateList(),
        MonitoringDataSaga.downloadCorporateMonitoringReport(),
        MonitoringDataSaga.downloadCorporateEWSReport(),
        MonitoringDataSaga.ewsPublishList(),
        MonitoringDataSaga.downloadMonitoringScoreCalcultionTemplate(),
        MonitoringDataSaga.publishMonitoringReport(),
        MonitoringDataSaga.downlodOldOrOfflineDataUploadTemplate(),
        MonitoringDataSaga.sendCorporateMonitoringReport(),
        MonitoringDataSaga.sendMonitoringBulkReport(),
        MonitoringDataSaga.fetchCorporateEws(),

        // Counterparty search
        CounterpartySearchSaga.counterpartySearch(),
        CounterpartySearchSaga.updateCounterpartyData(),
        CounterpartySearchSaga.updateCounterpartyMasterData(),
        AllocatePartnerSaga.fetchSortedPartnerListData(),
        AllocatePartnerSaga.allocatePartnerData(),
        AllocatePartnerSaga.fetchAllocatedPartnerData(),
        AllocatePartnerSaga.searchCounterpartyData(),
        AllocatePartnerSaga.fetchAllocatedSearchData(),
        AllocatePartnerSaga.fetchPartnerProductList(),
        AllocatePartnerSaga.fetchPartnerOrderData(),
        AllocatePartnerSaga.updateAdditionalDetails(),
        AllocatePartnerSaga.reallocatePartnerData(),
        
        // International Dashboard
        InternationalSaga.fetchPartnerOrders(),

        //EWS
        EWSSaga.fetchEwsCounterparties(),
        EWSSaga.fetchFilteredEwsCounterparties(),
        EWSSaga.ewsPlanList(),
        EWSSaga.ewsOptIn(),
        EWSSaga.ewsPlan(),
        EWSSaga.downloadCPUploadTemplate(),
        EWSSaga.counterpartyUpload(),
        EWSSaga.addPlan(),
        EWSSaga.updatePlanInMapping(),
        EWSSaga.crawlerStatusReport(),
        EWSSaga.reinitiateCrawlers(),
        EWSSaga.getDayOfMonth(),
        EWSSaga.updateDayOfMonth(),
        EWSSaga.runEWS(),
        EWSSaga.ewsReportDataUploadTemplate(),
        EWSSaga.ewsReportDataUpload(),
        EWSSaga.corporateCounterpartyList(),
        EWSSaga.ewsBulkOptin(),
        EWSSaga.bulkCrawlerStatusReport(),
        EWSSaga.publishUnpublishEWSReport(),
        EWSSaga.publishData(),
        EWSSaga.getPublishList(),
        EWSSaga.createEWSPublish(),
        EWSSaga.downloadEWSReportByDate(),
        EWSSaga.deletePublish(),
        EWSSaga.sendEWSIndividualMail(),
        EWSSaga.ewsReportWithFinancial(),
        EwsReportSaga.getEwsReportList(),
        EWSSaga.ewsTodoOptinScheduler(),
        EWSSaga.ewsOptedOutReport(),
        EWSSaga.ewsCorporateNamesDownload(),
        EWSSaga.ewsCorporateNamesUpload(),

        //Kyc Usage
        KycUsageSaga.kycUsageStatsFileRequest(),
        KycUsageSaga.kycApiUsageStatsFileRequest(),
        KycUsageSaga.kycUsageMeteringReportFileRequest(),
        KycUsageSaga.getKycPricingRequestTemplate(),
        KycUsageSaga.submitKycPricingRequest(),

        //Ratings Data Upload
        RatingsDataUploadSaga.uploadRatingsData(),
        APICasesExtractSaga.apiCasesExtractDownload(),

        //Utility Data Upload
        DataUploadSaga.dataUpload(),

        DataUploadSaga.getDataList(),
        DataUploadSaga.downloadStarRatingResult(),


        VendorDataSaga.fetchVendorTrackingData(),
        MisFormFieldSaga.createMisFormField(),
        MisFormFieldSaga.getMisFormFieldFilteredList(),
        MisFormFieldSaga.getMasterData(),
        AutomatedRevenueSaga.fetchCalculationParameterData(),
        AutomatedRevenueSaga.fetchCalculateRevenueData(),
        AutomatedBenchmarkSaga.fetchBenchmarkCalculationParameterData(),
        AutomatedBenchmarkSaga.fetchCalculateBenchmarkData(),
        CreditLimitEditSectionSaga.getCreditLimitModelAtSectionSaga(),
        CreditLimitEditSectionSaga.recalculatecreditLimitAtSectionSaga(),
        CreditLimitEditSectionSaga.saveCreditLimitModelAtSectionSaga(),

        MeteringSystemSaga.uploadMeteringExcelFile(),
        CaseViewSaga.previewDownloadedCase(),
        CaseViewSaga.getKybDetails(),
        CaseViewSaga.kybSubmitRecord(),
        MeteringSystemSaga.downloadExcelFile(),
        MeteringSystemSaga.meteringSystemData(),
        MeteringSystemSaga.meteringSystemExcelDownloadFile(),
        CorporateCaseCount.getCorporateCaseCount(),
        CorporateCaseCount.getCorporateList(),
        MeteringSystemSaga.fetchMailConfig(),
        MeteringSystemSaga.saveMailConfig(),
        MeteringSystemSaga.checkAgreementStatus(),
        MeteringSystemSaga.notifySalesAssociate(),
        MisTeamSaga.fetchMisTeamById(),
        MisTeamSaga.getMisTeam(),
        MisTeamSaga.updateMisTeam(),
        MisTeamSaga.fetchDefaultMisFields(),
        MisTeamSaga.fetchMisFields(),
        IfscMasterSaga.ifscMasterTemplate(),
        IfscMasterSaga.submitIfscMasterRequest(),
        IfscMasterSaga.ifscMasterDataExcel(),
        IfscMasterSaga.fetchIfscMasterList(),
        LocalPartyMasterSaga.localPartyMasterTemplate(),
        LocalPartyMasterSaga.submitLocalPartyMasterRequest(),
        LocalPartyMasterSaga.localPartyMasterDataExcel(),
        LocalPartyMasterSaga.fetchLocalPartyMasterList(),
        IfscUserMasterSaga.ifscUserMasterTemplate(),
        IfscUserMasterSaga.submitIfscUserMasterRequest(),
        IfscUserMasterSaga.ifscUserMasterDataExcel(),
        IfscUserMasterSaga.fetchIfscUserMasterList(),
        CorporateBillingMasterSaga.corporateBillingMasterTemplate(),
        CorporateBillingMasterSaga.submitCorporateBillingMasterRequest(),
        CorporateBillingMasterSaga.corporateBillingMasterDataExcel(),
        CorporateMasterSaga.corporateMasterTemplate(),
        CorporateMasterSaga.submitCorporateMasterRequest(),
        CorporateMasterSaga.fetchCorporateMasterList(),
        ActivityLogSaga.activityLogExtractDownload(),
        CorporateMasterSaga.corporateMasterDataExcel(),
        UserAccessMgtSaga.accessManagementCorporateList(),
        UserAccessMgtSaga.getAnalystsListSaga(),
        UserAccessMgtSaga.usersSelectedCorporates(),
        UserAccessMgtSaga.usersCorporates(),

        PartnerCostSaga.downloadCostExcelTemplateSaga(),
        PartnerCostSaga.downloadCostExcelSaga(),
        PartnerCostSaga.uploadPartnerCostExcelFileSaga(),
        CorporateMasterSaga.corporateMasterDataExcel(),
        CorporateMasterSaga.corporateMasterGetCorporates(),

        DatabaseRequestCase.databaseCaseCreation(),
        CountryIndustryReports.fetchCountryIndustryReportsListSaga(),
        CountryIndustryReports.watchCreateReport(),
        CountryIndustryReports.watchEditReport(),
        CountryIndustryReports.watchDeleteReport(),
        BulkCaseUpdationSaga.fetchCorporateAutocompleteSaga(),
        BulkCaseUpdationSaga.productByCorporateWatcher(),
        BulkCaseUpdationSaga.downloadBulkReportExcelWatcher(),
        BulkCaseUpdationSaga.bulkCaseUpdationWatcher(),
        BulkCaseUpdationSaga.fetchBulkCaseUpdationListWatcher(),
        BulkCaseUpdationSaga.downloadBulkCaseUpdationFileWatcher(),
        SupportWorkAutomationSaga.watchFetchSupportCaseDetails(),
        SupportWorkAutomationSaga.watchTakeSupportAutomationBackup(),
        SupportWorkAutomationSaga.watchDeleteFinancialFormData(),
        SupportWorkAutomationSaga.watchDeleteExecutiveSummaryFinancialData(),
]);
}
